/**
 * Convert strings that may contain raw HTML (e.g. errant LLM output) to readable plain text
 * for multiline form fields, so <p>, <br>, <strong> etc. never show as visible markup.
 */
export function stripHtmlToPlainText(value) {
  if (value == null) return '';
  let s = String(value);
  if (!s) return '';
  s = s.replace(/<style[\s\S]*?<\/style>/gi, ' ');
  s = s.replace(/<script[\s\S]*?<\/script>/gi, ' ');
  s = s.replace(/<br\s*\/?>/gi, '\n');
  s = s.replace(/<\/(p|div|h[1-6]|tr)>/gi, '\n');
  s = s.replace(/<\/(li)>/gi, '\n');
  s = s.replace(/<li[^>]*>/gi, '\n• ');
  s = s.replace(/<\/(ol|ul)>/gi, '\n');
  s = s.replace(/<[^>]+>/g, ' ');
  s = s.replace(/&nbsp;/gi, ' ');
  s = s.replace(/&#160;/g, ' ');
  s = s.replace(/&amp;/g, '\uE000');
  s = s.replace(/&lt;/g, '<');
  s = s.replace(/&gt;/g, '>');
  s = s.replace(/&quot;/g, '"');
  s = s.replace(/&#0*39;|&apos;/gi, "'");
  s = s.replace(/\uE000/g, '&');
  s = s.replace(/[ \t]+/g, ' ');
  s = s.replace(/ *\n */g, '\n');
  s = s.replace(/\n{3,}/g, '\n\n');
  return s.trim();
}
